import { getQuery, insertQuery, updateQuery } from "./UdasWrapper";
import { addErrorLog } from "../Logger/logger";

export const fetchRoles = async (tenant_id) => {
  try {
    const data = JSON.stringify({
      query: `query Roles($tenant_id: String!) {
        roles(tenant_id: $tenant_id) {
          id
          tenant_id
          description
          created_by
          created_date_time
          name
          notes
          status
          user_type
          created_by_role_id
        }
      }`,
      variables: {
        tenant_id: tenant_id
      }
    });
    const result = await getQuery(data);
    return result?.roles;
  } catch (error) {
    console.error(error);
    addErrorLog("fetchRoles", error);
    return null;
  }
};

export const updateRoles = async (tenant_id, role_id, input) => {
  console.log("UPDATE ROLE (API CALL)");
  const data = JSON.stringify({
    query: `mutation UpdateRoles($tenantId: String!, $updateRolesId: String!, $input: RolesInput) {
      updateRoles(tenant_id: $tenantId, id: $updateRolesId, input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId: tenant_id,
      updateRolesId: role_id,
      input: input
    }
  });

  try {
    const result = await updateQuery(data);
    if (!result?.updateRoles?.isSuccessful) {
      throw new Error("Invalid response from updateRoles API");
    }
    return result.updateRoles;
  } catch (error) {
    console.error("Error in updateRoles:", error);
    addErrorLog("updateRoles", error);
    return null;
  }
};

export const updateUserRoles = async (tenant_id, user_id, role_id) => {
  console.log("UPDATE USER ROLE (API CALL");
  const data = JSON.stringify({
    query: `mutation UpdateUserRole($tenantId: String, $auth0Id: String, $roleId: ID) {
      updateUserRole(tenant_id: $tenantId, auth0_id: $auth0Id, role_id: $roleId) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId: tenant_id,
      auth0Id: user_id,
      roleId: role_id
    }
  });

  try {
    const result = await updateQuery(data);
    if (!result?.updateUserRole?.isSuccessful) {
      throw new Error("Invalid response from updateUserRole API");
    }
    return result.updateUserRole;
  } catch (error) {
    console.error("Error in updateUserRoles:", error);
    addErrorLog("updateUserRoles", error);
    return null;
  }
};

export const removeUserRole = async (tenant_id, user_id) => {
  console.log("REMOVE USER ROLE (API CALL)");
  const data = JSON.stringify({
    query: `mutation UpdateUserRole($tenantId: String, $auth0Id: String) {
      removeUserRole(tenant_id: $tenantId, auth0_id: $auth0Id) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId: tenant_id,
      auth0Id: user_id
    }
  });

  try {
    const result = await updateQuery(data);
    if (!result || !result.removeUserRole) {
      throw new Error("Invalid response from removeUserRole API");
    }
    return result.removeUserRole;
  } catch (error) {
    console.error("Error in removeUserRole:", error);
    addErrorLog("removeUserRole", error);
    return null;
  }
};

export const deleteRoles = async (tenant_id, delete_roles_id) => {
  console.log("DELETE ROLE (API CALL)");
  const data = JSON.stringify({
    query: `mutation DeleteRoles($tenantId: String!, $deleteRolesId: String!) {
      deleteRoles(tenant_id: $tenantId, id: $deleteRolesId) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId: tenant_id,
      deleteRolesId: delete_roles_id
    }
  });

  try {
    const result = await updateQuery(data);
    if (!result || !result.deleteRoles) {
      throw new Error("Invalid response from deleteRoles API");
    }
    return result.deleteRoles;
  } catch (error) {
    console.error("Error in deleteRoles:", error);
    addErrorLog("deleteRoles", error);
    return null;
  }
};

export const createRole = async (tenant_id, input) => {
  let data = JSON.stringify({
    query: `mutation CreateRoles($tenant_id: String!, $input: RolesInput) {
            createRoles(tenant_id: $tenant_id, input: $input) {
              isSuccessful
              message
              resultObject
            }
          }`,
    variables: {
      tenant_id,
      input
    }
  });

  try {
    const result = await insertQuery(data);
    if (!result || !result.createRoles) {
      throw new Error("Invalid response from createRoles API");
    }
    return result.createRoles;
  } catch (error) {
    console.error("Error in createRoles:", error);
    addErrorLog("createRoles", error);
    return null;
  }
};
